import AuthService from '@root/core/src/services/auth-service';
import Button from '@root/core/src/components/button';
import Responsive from '@root/core/src/utils/responsive';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { Col, Container, Row } from '@root/core/src/components/grid';
import { SUPPORT_EMAIL } from '@root/core/src/models/email';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

export default function QuotesStuck() {
  const { trackClick } = useAnalytics('QUOTES_STUCK');
  const { accountId, userId } = AuthService.getCurrentUserContext();

  const emailBody = encodeURIComponent('An issue occurred on the Root Web application while attempting to view available quotes.\n\n' +
    `Account ID: ${accountId}\n` +
    `User ID: ${userId}\n\n` +
    'Please include any additional information you would like Root’s Support Team to know below and we will be in contact with you shortly:\n');

  return (
    <div css={styles.outerContainer}>
      <Container css={styles.container}>
        <Row css={styles.centerAlign}>
          <Col
            css={styles.padBottom}
            lg={5}
            md={7}
            xl={5}
            xs={12}
          >
            <p css={styles.title}>Oops, something went wrong.</p>
            <p css={styles.body}>
              We weren’t able to determine your quote. There may be an issue with your profile that our team can help you correct.
            </p>
            <a
              css={styles.link}
              href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('Support Team - Root Web Issue')}&body=${emailBody}`}
            >
              <Button onClick={() => trackClick('CONTACT_SUPPORT')}>
                Contact support
              </Button>
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const styles = StyleSheet.create({
  body: {
    ...Theme.paragraph1(),
  },
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  centerAlign: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
  },
  title: {
    ...Theme.heading1(),
  },
  link: {
    '&:hover': { textDecoration: 'none' },
  },
  padBottom: {
    paddingBottom: '10vh',
    ...Responsive.sm({
      paddingBottom: '20vh',
    }),
  },
});
